import { STORIES_BASE_PATH} from "@/constants/routes";

export const ugcPage = {
  metadata: {
    title: "Stories of People Who Shaped America - Ancestry",
    description: "Learn about the family members of real Ancestry users who helped build the United States that we know today. ",
    other: {
      'data-screen-name': `lohp-ui : stories-of-us : subpages : 250-stories`,
    },
  }
}

export const categories = [
  {
    slug: 'featured',
    title: 'Featured Records',
    label: 'Women\'s History Month',
    intro: 'Discover the records of women who’ve made enduring contributions to our country’s history, culture, and society.',
    metadata: {
      title: "Explore Inspiring Record Stories - Ancestry",
      description: "Discover extraordinary human stories and history in our curated gallery of inspiring records.",
      other: {
        'data-screen-name': `lohp-ui : stories-of-us : subpages : record-gallery`,
      },
    }
  },
  {
    slug: 'culture-and-heritage',
    title: 'Culture & Heritage',
    label: 'The country seen through many eyes',
    intro: 'Our collective story is stronger with the breadth and diversity of the American experience.',
    metadata: {
      title: "Explore Culture and Heritage Stories - Ancestry",
      description: "Discover the powerful stories and rich heritage of our ancestors through curated records.",
      other: {
        'data-screen-name': `lohp-ui : stories-of-us : subpages : record-gallery : culture-and-heritage`,
      },
    }
  },
  {
    slug: 'innovators-and-visionaries',
    title: 'Innovators & Visionaries',
    label: 'People who paved new paths',
    intro: 'This country has always been a place of ingenuity and innovation—see how records can tell even more of this story.',
    metadata: {
      title: "Meet Inspiring Innovators - Ancestry",
      description: "Discover the visionary minds and groundbreaking innovations that changed the world.",
      other: {
        'data-screen-name': `lohp-ui : stories-of-us : subpages : record-gallery : innovators-and-visionaries`,
      },
    }
  },
  {
    slug: 'service-and-sacrifice',
    title: 'Service & Sacrifice',
    label: 'Bravery takes many forms over 250 years',
    intro: 'The story of the United States is filled with resilient women and men who stepped up when the country called.',
    metadata: {
      title: "Explore Service and Sacrifice Stories - Ancestry",
      description: "Discover the brave human stories of commitment and courage in our service and sacrifice gallery.",
      other: {
        'data-screen-name': `lohp-ui : stories-of-us : subpages : record-gallery : service-and-sacrifice`,
      },
    }
  },
  {
    slug: 'icons-and-influencers',
    title: 'Icons & Influencers',
    label: 'they shaped art, music, sports, and more',
    intro: 'Discover new details about some of your favorite icons and legends—all with the help of our rich record collections.',
    metadata: {
      title: "Discover Iconic Stories & Influence - Ancestry",
      description: "Discover the extraordinary human stories behind the world's most iconic and influential figures.",
      other: {
        'data-screen-name': `lohp-ui : stories-of-us : subpages : record-gallery : icons-and-influencers`,
      },
    }
  },
  {
    slug: 'labor-and-livelihood',
    title: 'Labor & Livelihood',
    label: 'IN PURSUIT OF THE AMERICAN DREAM',
    intro: 'Hope, ambition, and grit led them to greatness in the face of hardships—these records show a part of their journey.',
    metadata: {
      title: "Labor and Livelihood Record Stories - Ancestry",
      description: "Discover inspiring stories of work and industry through our curated record gallery.",
      other: {
        'data-screen-name': `lohp-ui : stories-of-us : subpages : record-gallery : labor-and-livelihood`,
      },
    }
  }

]

export const stories = [
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-innovators-and-visionaries-1',
    category: 'innovators-and-visionaries',
    isFeatured: true,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/test-1.png',
      width: 381,
      height: 418
    },
    artifact_1: {
      alt: 'placeholder',
      src: '/img/placeholder/test-1-artifact-1.png',
      pos: "front",
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth’s life before baseball',
      name: 'George Herman “Babe” Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth’s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth’s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-culture-and-heritage-1',
    category: 'culture-and-heritage',
    isFeatured: true,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/test-2.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth’s life before baseball',
      name: 'George Herman “Babe” Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth’s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth’s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-service-and-sacrifice-1',
    category: 'service-and-sacrifice',
    isFeatured: true,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/test-3.png',
      width: 381,
      height: 418
    },
    artifact_1: {
      alt: 'placeholder',
      src: '/img/placeholder/test-3-artifact-1.png',
      pos: "front",
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth’s life before baseball',
      name: 'George Herman “Babe” Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth’s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage-2.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth’s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/placeholder-record-2.webp',
          width: 1276,
          height: 1546
        }
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-labor-and-livelihood-1',
    category: 'labor-and-livelihood',
    isFeatured: true,
    image: {
      alt: 'placeholder',
      width: 381,
      height: 418,
      src: '/img/placeholder/test-4.png'
    },
    artifact_1: {
      alt: 'placeholder',
      src: '/img/placeholder/test-4-artifact-1.png',
      pos: "front",
      width: 381,
      height: 418
    },
    artifact_2: {
      alt: 'placeholder',
      src: '/img/placeholder/test-4-artifact-2.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth’s life before baseball',
      name: 'George Herman “Babe” Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth’s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth’s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-icons-and-influencers-1',
    category: 'icons-and-influencers',
    isFeatured: true,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/test-5.png',
      width: 381,
      height: 418
    },
    artifact_1: {
      alt: 'placeholder',
      src: '/img/placeholder/test-5-artifact-1.png',
      pos: "front",
      width: 381,
      height: 418
    },
    artifact_2: {
      alt: 'placeholder',
      src: '/img/placeholder/test-5-artifact-2.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth’s life before baseball',
      name: 'George Herman “Babe” Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth’s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth’s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-innovators-and-visionaries-2',
    category: 'innovators-and-visionaries',
    isFeatured: true,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/test-6.png',
      width: 381,
      height: 418
    },
    artifact_1: {
      alt: 'placeholder',
      src: '/img/placeholder/test-6-artifact-1.png',
      pos: "front",
      width: 381,
      height: 418
    },

    content: {
      title: 'Babe Ruth’s life before baseball',
      name: 'George Herman “Babe” Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth’s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage-3.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth’s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/placeholder-record-3.webp',
          width: 1276,
          height: 1546
        }
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-culture-and-heritage-2',
    category: 'culture-and-heritage',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth’s life before baseball',
      name: 'George Herman “Babe” Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth’s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth’s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-service-and-sacrifice-2',
    category: 'service-and-sacrifice',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth’s life before baseball',
      name: 'George Herman “Babe” Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth’s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth’s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-labor-and-livelihood-2',
    category: 'labor-and-livelihood',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth’s life before baseball',
      name: 'George Herman “Babe” Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth’s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth’s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-icons-and-influencers-2',
    category: 'icons-and-influencers',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth’s life before baseball',
      name: 'George Herman “Babe” Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth’s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth’s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-innovators-and-visionaries-3',
    category: 'innovators-and-visionaries',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth’s life before baseball',
      name: 'George Herman “Babe” Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth’s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth’s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-culture-and-heritage-3',
    category: 'culture-and-heritage',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth’s life before baseball',
      name: 'George Herman “Babe” Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth’s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth’s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-service-and-sacrifice-3',
    category: 'service-and-sacrifice',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth’s life before baseball',
      name: 'George Herman “Babe” Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth’s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth’s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-labor-and-livelihood-3',
    category: 'labor-and-livelihood',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth’s life before baseball',
      name: 'George Herman “Babe” Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth’s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth’s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-icons-and-influencers-3',
    category: 'icons-and-influencers',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth’s life before baseball',
      name: 'George Herman “Babe” Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth’s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth’s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-innovators-and-visionaries-4',
    category: 'innovators-and-visionaries',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth’s life before baseball',
      name: 'George Herman “Babe” Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth’s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth’s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-culture-and-heritage-4',
    category: 'culture-and-heritage',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth’s life before baseball',
      name: 'George Herman “Babe” Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth’s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth’s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-service-and-sacrifice-4',
    category: 'service-and-sacrifice',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth’s life before baseball',
      name: 'George Herman “Babe” Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth’s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth’s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-labor-and-livelihood-4',
    category: 'labor-and-livelihood',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth’s life before baseball',
      name: 'George Herman “Babe” Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth’s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth’s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-icons-and-influencers-4',
    category: 'icons-and-influencers',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth’s life before baseball',
      name: 'George Herman “Babe” Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth’s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth’s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-innovators-and-visionaries-5',
    category: 'innovators-and-visionaries',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth’s life before baseball',
      name: 'George Herman “Babe” Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth’s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth’s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-culture-and-heritage-5',
    category: 'culture-and-heritage',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth’s life before baseball',
      name: 'George Herman “Babe” Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth’s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth’s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-service-and-sacrifice-5',
    category: 'service-and-sacrifice',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth’s life before baseball',
      name: 'George Herman “Babe” Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth’s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth’s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-labor-and-livelihood-5',
    category: 'labor-and-livelihood',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth’s life before baseball',
      name: 'George Herman “Babe” Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth’s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth’s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-icons-and-influencers-5',
    category: 'icons-and-influencers',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth’s life before baseball',
      name: 'George Herman “Babe” Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth’s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth’s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-innovators-and-visionaries-6',
    category: 'innovators-and-visionaries',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth’s life before baseball',
      name: 'George Herman “Babe” Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth’s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth’s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-culture-and-heritage-6',
    category: 'culture-and-heritage',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth’s life before baseball',
      name: 'George Herman “Babe” Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth’s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth’s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-service-and-sacrifice-6',
    category: 'service-and-sacrifice',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth’s life before baseball',
      name: 'George Herman “Babe” Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth’s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth’s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-labor-and-livelihood-6',
    category: 'labor-and-livelihood',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth’s life before baseball',
      name: 'George Herman “Babe” Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth’s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth’s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-icons-and-influencers-6',
    category: 'icons-and-influencers',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth’s life before baseball',
      name: 'George Herman “Babe” Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth’s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth’s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-innovators-and-visionaries-7',
    category: 'innovators-and-visionaries',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth’s life before baseball',
      name: 'George Herman “Babe” Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth’s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth’s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-culture-and-heritage-7',
    category: 'culture-and-heritage',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth’s life before baseball',
      name: 'George Herman “Babe” Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth’s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth’s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-service-and-sacrifice-7',
    category: 'service-and-sacrifice',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth’s life before baseball',
      name: 'George Herman “Babe” Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth’s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth’s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-labor-and-livelihood-7',
    category: 'labor-and-livelihood',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth’s life before baseball',
      name: 'George Herman “Babe” Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth’s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth’s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-icons-and-influencers-7',
    category: 'icons-and-influencers',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth’s life before baseball',
      name: 'George Herman “Babe” Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth’s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth’s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-innovators-and-visionaries-8',
    category: 'innovators-and-visionaries',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth\'s life before baseball',
      name: 'George Herman "Babe" Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth\'s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth\'s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-culture-and-heritage-8',
    category: 'culture-and-heritage',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth\'s life before baseball',
      name: 'George Herman "Babe" Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth\'s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth\'s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It\'s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked "occupation," the handwriting reads: Baseball Player. For "employer," it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet "The Babe," not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card\'s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-service-and-sacrifice-8',
    category: 'service-and-sacrifice',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth\'s life before baseball',
      name: 'George Herman "Babe" Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth\'s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth\'s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It\'s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked "occupation," the handwriting reads: Baseball Player. For "employer," it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet "The Babe," not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card\'s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-labor-and-livelihood-8',
    category: 'labor-and-livelihood',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth\'s life before baseball',
      name: 'George Herman "Babe" Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth\'s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth\'s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It\'s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked "occupation," the handwriting reads: Baseball Player. For "employer," it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet "The Babe," not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card\'s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-icons-and-influencers-8',
    category: 'icons-and-influencers',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth\'s life before baseball',
      name: 'George Herman "Babe" Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth\'s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth\'s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It\'s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked "occupation," the handwriting reads: Baseball Player. For "employer," it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet "The Babe," not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card\'s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-innovators-and-visionaries-9',
    category: 'innovators-and-visionaries',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth\'s life before baseball',
      name: 'George Herman "Babe" Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth\'s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth\'s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It\'s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked "occupation," the handwriting reads: Baseball Player. For "employer," it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet "The Babe," not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card\'s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-culture-and-heritage-9',
    category: 'culture-and-heritage',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth\'s life before baseball',
      name: 'George Herman "Babe" Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth\'s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth\'s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It\'s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked "occupation," the handwriting reads: Baseball Player. For "employer," it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet "The Babe," not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card\'s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-service-and-sacrifice-9',
    category: 'service-and-sacrifice',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth\'s life before baseball',
      name: 'George Herman "Babe" Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth\'s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth\'s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It\'s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked "occupation," the handwriting reads: Baseball Player. For "employer," it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet "The Babe," not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card\'s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-labor-and-livelihood-9',
    category: 'labor-and-livelihood',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth\'s life before baseball',
      name: 'George Herman "Babe" Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth\'s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth\'s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It\'s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked "occupation," the handwriting reads: Baseball Player. For "employer," it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet "The Babe," not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card\'s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-icons-and-influencers-9',
    category: 'icons-and-influencers',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth\'s life before baseball',
      name: 'George Herman "Babe" Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth\'s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth\'s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It\'s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked "occupation," the handwriting reads: Baseball Player. For "employer," it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet "The Babe," not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card\'s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-innovators-and-visionaries-10',
    category: 'innovators-and-visionaries',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth\'s life before baseball',
      name: 'George Herman "Babe" Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth\'s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth\'s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It\'s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked "occupation," the handwriting reads: Baseball Player. For "employer," it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet "The Babe," not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card\'s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-culture-and-heritage-10',
    category: 'culture-and-heritage',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth\'s life before baseball',
      name: 'George Herman "Babe" Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth\'s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth\'s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It\'s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked "occupation," the handwriting reads: Baseball Player. For "employer," it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet "The Babe," not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card\'s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-service-and-sacrifice-10',
    category: 'service-and-sacrifice',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth\'s life before baseball',
      name: 'George Herman "Babe" Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth\'s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth\'s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It\'s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked "occupation," the handwriting reads: Baseball Player. For "employer," it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet "The Babe," not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card\'s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-labor-and-livelihood-10',
    category: 'labor-and-livelihood',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth\'s life before baseball',
      name: 'George Herman "Babe" Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth\'s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth\'s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It\'s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked "occupation," the handwriting reads: Baseball Player. For "employer," it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet "The Babe," not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card\'s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
  {
    date: 2016,
    text: "Pivotal events that shaped a nation and influenced the world",
    slug: 'record-icons-and-influencers-10',
    category: 'icons-and-influencers',
    isFeatured: false,
    image: {
      alt: 'placeholder',
      src: '/img/placeholder/record-card.png',
      width: 381,
      height: 418
    },
    content: {
      title: 'Babe Ruth\'s life before baseball',
      name: 'George Herman "Babe" Ruth',
      location: 'Chicago, IL',
      date: '1872 – 1923',
      text: 'Before he was known for home runs, Babe Ruth\'s signature appeared on more than baseballs—he signed up for the WWI draft in 1917.',
      image: {
        alt: 'placeholder',
        src: '/img/placeholder/placeholder-collage.webp',
        width: 1040,
        height: 1392
      },
      record: {
        title: 'World War I Draft Card',
        text: 'Can you identify Babe Ruth\'s place of birth listed in the record?',
        image: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
        thumbnail: {
          alt: 'placeholder',
          src: '/img/placeholder/record.png',
          width: 1276,
          height: 1546
        },
      },
      audioTrack: {
        src: '/audio/placeholder/story.mp3',
        transcript: [
          'It\'s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked "occupation," the handwriting reads: Baseball Player. For "employer," it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet "The Babe," not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card\'s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
          'It’s a standard government form, one of millions printed in the spring of 1917. But the details here tell a different story. In the field marked “occupation,” the handwriting reads: Baseball Player. For “employer,” it specifies the Boston American League Baseball Club. This is the draft card of George Herman Ruth—not yet “The Babe,” not yet a myth, but a 22-year-old professional athlete fulfilling a civic obligation. The signature is unadorned, practical. In that line, he was no different from any other young man in Boston, stepping forward as the nation prepared for war.',
          'The card’s true narrative, however, is in its administrative aftermath. A note indicates he had a dependent wife. More significantly, the local draft board classified him as deferred. The reasoning, though not written here, was clear in the context of the time: his perceived value to public morale was deemed a form of national service. So this document, a snapshot of potential, became a historical pivot point. It captured the instant the trajectory of a cultural icon intersected with the machinery of the state—and was quietly redirected back to the ballpark, where a different kind of legend was waiting to be built.',
        ]
      }
    }
  },
].map((story, index) => {
  return { ...story, date: story.date + '-' + index }
})

export const ugcStories = Array.from({ length: 250 }, (_, i) => {
  const index = i + 1;
  const imageNum = (i % 7) + 1;
  const isPortrait = imageNum === 1 || imageNum === 3 || imageNum === 4 || imageNum === 5;
  return {
    slug: `ugc-story-${index}`,
    title: 'My great grandmother Thelma in 1924',
    name: 'Lisa S.',
    location: 'Provincetown, RI',
    text: 'Here is my great-grandmother, a face I know only from albums and family lore. Holding this photo, I feel a profound sense of gratitude. Her journey, her choices, her love—they all led, somehow, to me. It\'s a humbling and powerful connection across the generations.',
    excerpt: 'My great-great-grandmother, Esmeralda, was a traveling botanist who discovered a rare orchid in the Amazon. When she was in her mid 20s, she studied at university',
    image: {
      alt: 'placeholder',
      src: `/img/placeholder/ugc-story-${imageNum}.webp`,
      width: 1040,
      height: isPortrait ? 1370 : 720
    }
  };
})


export const stateLocations = [
  { name: 'Alabama', abbreviation: 'AL', x: 70.6, y: 52.9, abbreviateAtZoom: 1 },
  { name: 'Alaska', abbreviation: 'AK', x: 11.2, y: 59.1 },
  { name: 'Arizona', abbreviation: 'AZ', x: 37.2, y: 49.4 },
  { name: 'Arkansas', abbreviation: 'AR', x: 62.8, y: 48.1, abbreviateAtZoom: 1 },
  { name: 'California', abbreviation: 'CA', x: 26.9, y: 44.1 },
  { name: 'Colorado', abbreviation: 'CO', x: 45.4, y: 38.4 },
  { name: 'Connecticut', abbreviation: 'CT', x: 89.8, y: 31.3, abbreviateAtZoom: 2 },
  { name: 'Delaware', abbreviation: 'DE', x: 85.6, y: 38.4, abbreviateAtZoom: 2 },
  { name: 'Florida', abbreviation: 'FL', x: 77.4, y: 63.6 },
  { name: 'Georgia', abbreviation: 'GA', x: 75.1, y: 53.1 },
  { name: 'Hawaii', abbreviation: 'HI', x: 28.4, y: 88.1 },
  { name: 'Idaho', abbreviation: 'ID', x: 33.9, y: 26.6 },
  { name: 'Illinois', abbreviation: 'IL', x: 67, y: 35.8, abbreviateAtZoom: 1 },
  { name: 'Indiana', abbreviation: 'IN', x: 71.3, y: 36.1, abbreviateAtZoom: 1 },
  { name: 'Iowa', abbreviation: 'IA', x: 61.5, y: 30 },
  { name: 'Kansas', abbreviation: 'KS', x: 55.4, y: 39.6 },
  { name: 'Kentucky', abbreviation: 'KY', x: 73.3, y: 42.1 },
  { name: 'Louisiana', abbreviation: 'LA', x: 64, y: 58, abbreviateAtZoom: 1 },
  { name: 'Maine', abbreviation: 'ME', x: 94, y: 21.6 },
  { name: 'Maryland', abbreviation: 'MD', x: 83.5, y: 37.2, abbreviateAtZoom: 2 },
  { name: 'Massachusetts', abbreviation: 'MA', x: 90.7, y: 29.9, abbreviateAtZoom: 2 },
  { name: 'Michigan', abbreviation: 'MI', x: 73.4, y: 27.3 },
  { name: 'Minnesota', abbreviation: 'MN', x: 60.1, y: 19.6 },
  { name: 'Mississippi', abbreviation: 'MS', x: 66.7, y: 52.6, abbreviateAtZoom: 1 },
  { name: 'Missouri', abbreviation: 'MO', x: 63, y: 40 },
  { name: 'Montana', abbreviation: 'MT', x: 40.4, y: 17.1 },
  { name: 'Nebraska', abbreviation: 'NE', x: 53.7, y: 32.1 },
  { name: 'Nevada', abbreviation: 'NV', x: 30.5, y: 37.1 },
  { name: 'New Hampshire', abbreviation: 'NH', x: 90.7, y: 26.6, abbreviateAtZoom: 2 },
  { name: 'New\nJersey', abbreviation: 'NJ', x: 86.8, y: 35.4, abbreviateAtZoom: 2 },
  { name: 'New\nMexico', abbreviation: 'NM', x: 44.7, y: 49.1 },
  { name: 'New\nYork', abbreviation: 'NY', x: 85.4, y: 28.3 },
  { name: 'North\nCarolina', abbreviation: 'NC', x: 80.6, y: 45.7, abbreviateAtZoom: 1 },
  { name: 'North\nDakota', abbreviation: 'ND', x: 52.5, y: 16.1 },
  { name: 'Ohio', abbreviation: 'OH', x: 76, y: 35.1 },
  { name: 'Oklahoma', abbreviation: 'OK', x: 56.5, y: 46.6 },
  { name: 'Oregon', abbreviation: 'OR', x: 25.5, y: 25.6 },
  { name: 'Pennsylvania', abbreviation: 'PA', x: 82.5, y: 33.6, abbreviateAtZoom: 1 },
  { name: 'Rhode Island', abbreviation: 'RI', x: 90.9, y: 32.7, abbreviateAtZoom: 2 },
  { name: 'South\nCarolina', abbreviation: 'SC', x: 78.6, y: 50.3, abbreviateAtZoom: 1 },
  { name: 'South\nDakota', abbreviation: 'SD', x: 52.5, y: 24.1 },
  { name: 'Tennessee', abbreviation: 'TN', x: 71.5, y: 46.1 },
  { name: 'Texas', abbreviation: 'TX', x: 54.4, y: 55.6 },
  { name: 'Utah', abbreviation: 'UT', x: 37.5, y: 38.6 },
  { name: 'Vermont', abbreviation: 'VT', x: 89.4, y: 25.1, abbreviateAtZoom: 2 },
  { name: 'Virginia', abbreviation: 'VA', x: 81.5, y: 42 },
  { name: 'Washington', abbreviation: 'WA', x: 26.2, y: 16.1 },
  { name: 'West\nVirginia', abbreviation: 'WV', x: 78.3, y: 39.4, abbreviateAtZoom: 1 },
  { name: 'Wisconsin', abbreviation: 'WI', x: 66.3, y: 24.1 },
  { name: 'Wyoming', abbreviation: 'WY', x: 42.7, y: 28.1 },
];

export const pinLocations = [
  { location: 'Alabama', abbreviation: 'AL', x: 72, y: 51, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Alaska', abbreviation: 'AK', x: 6.2, y: 60.5, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Arizona', abbreviation: 'AZ', x: 33.5, y: 53.2, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Arkansas', abbreviation: 'AR', x: 61, y: 44.7, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'California', abbreviation: 'CA', x: 23, y: 41.4, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Colorado', abbreviation: 'CO', x: 46, y: 36, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Connecticut', abbreviation: 'CT', x: 88.4, y: 32.6, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Delaware', abbreviation: 'DE', x: 85.3, y: 36.6, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Florida', abbreviation: 'FL', x: 79.3, y: 66.5, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Georgia', abbreviation: 'GA', x: 73.5, y: 51, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Hawaii', abbreviation: 'HI', x: 25, y: 86, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Idaho', abbreviation: 'ID', x: 31.2, y: 26.3, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Illinois', abbreviation: 'IL', x: 69.1, y: 31.5, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Indiana', abbreviation: 'IN', x: 69.8, y: 37.5, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Iowa', abbreviation: 'IA', x: 61.5, y: 32, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Kansas', abbreviation: 'KS', x: 58.5, y: 38.7, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Kentucky', abbreviation: 'KY', x: 72.1, y: 40, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Louisiana', abbreviation: 'LA', x: 66.3, y: 59.1, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Maine', abbreviation: 'ME', x: 94.7, y: 24.5, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Maryland', abbreviation: 'MD', x: 83.1, y: 37.2, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Massachusetts', abbreviation: 'MA', x: 91.9, y: 31, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Michigan', abbreviation: 'MI', x: 74.5, y: 30.5, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Minnesota', abbreviation: 'MN', x: 61.8, y: 23.4, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Mississippi', abbreviation: 'MS', x: 64.6, y: 55.5, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Missouri', abbreviation: 'MO', x: 65.8, y: 39.1, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Montana', abbreviation: 'MT', x: 38.3, y: 21.5, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Nebraska', abbreviation: 'NE', x: 57.5, y: 31, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Nevada', abbreviation: 'NV', x: 32.5, y: 45.5, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'New Hampshire', abbreviation: 'NH', x: 91, y: 27, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'New Jersey', abbreviation: 'NJ', x: 86.6, y: 35, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'New Mexico', abbreviation: 'NM', x: 44.7, y: 46.3, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'New York', abbreviation: 'NY', x: 87.5, y: 34.1, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'North Carolina', abbreviation: 'NC', x: 82, y: 45.9, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'North Dakota', abbreviation: 'ND', x: 56, y: 15, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Ohio', abbreviation: 'OH', x: 74, y: 36.5, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Oklahoma', abbreviation: 'OK', x: 58.5, y: 48, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Oregon', abbreviation: 'OR', x: 22.4, y: 21.4, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Pennsylvania', abbreviation: 'PA', x: 86, y: 35.5, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Rhode Island', abbreviation: 'RI', x: 90.8, y: 32, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'South Carolina', abbreviation: 'SC', x: 78, y: 51.4, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'South Dakota', abbreviation: 'SD', x: 52, y: 27.5, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Tennessee', abbreviation: 'TN', x: 66.2, y: 47.4, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Texas', abbreviation: 'TX', x: 60.5, y: 52.2, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Utah', abbreviation: 'UT', x: 37.5, y: 37.6, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Vermont', abbreviation: 'VT', x: 89.4, y: 28, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Virginia', abbreviation: 'VA', x: 81.5, y: 41.5, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Washington', abbreviation: 'WA', x: 23.3, y: 16.1, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'West Virginia', abbreviation: 'WV', x: 79.8, y: 37.7, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Wisconsin', abbreviation: 'WI', x: 68.9, y: 28, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
  { location: 'Wyoming', abbreviation: 'WY', x: 42.7, y: 27.4, text: 'Vintage photo of a young man named Jasper Hale, Civil War Hero', image: { src: '/img/placeholder/placeholder-map-card.webp', width: 176, height: 208, alt: 'placeholder image' }, link: { href: `${STORIES_BASE_PATH}/record-gallery/culture-and-heritage/record-culture-and-heritage-1` } },
]
